import StayStatus from './StayStatus';
export type { StayStatusProps } from './StayStatus.types';

export default StayStatus;
